import React from "react";
import Image from "../../Tags/Image";

export default function Platforms({ data }) {
  const returnImg = (type) => {
    if (type) {
      // const newitem = item.toLowerCase();
      if (type === "macos") {
        return "/images/ext/companyinfo/mac.svg";
      } else if (type === "linux") {
        return "/images/ext/companyinfo/linux.svg";
      } else if (type === "windows") {
        return "/images/ext/companyinfo/windows.svg";
      } else if (type === "ios") {
        return "/images/ext/companyinfo/appstore.svg";
      } else if (type === "android") {
        return "/images/ext/companyinfo/playstore.svg";
      } else {
        return "/images/ext/companyinfo/code.svg";
      }
    } else {
      return "/images/ext/companyinfo/code.svg";
    }
  };
  return (
    <>
      {data && data.length > 0 && (
        <div className="border rounded-[14px] overflow-hidden border-border  bg-background relative mt-4 p-4 pb-2">
          <div className="mb-4">
            <span className="text-[16px] text-text-700 mr-3 font-bold">Supported Platforms</span>
            <span className="block text-sm">Get a view of the supported operating systems and devices</span>
          </div>

          <div className="mt-3 -mr-3">
            {data.map((item) => (
              <>
                <div className="border rounded-[14px] overflow-hidden border-input  bg-gray-100 relative p-4 w-[48.5%] inline-block mr-[1.5%] mb-[1%]">
                  <div className="flex items-center justify-between">
                    <span className="inline-flex items-center">
                      <Image src={returnImg(item?.type)} className="mr-3 no-invert" />
                      <div className="inline-flex">
                        <span className="text-[16px] text-gray-900 block">{item?.name}</span>
                      </div>
                    </span>
                    <Image className="no-invert" src="/images/ext/check-purple.svg" width={20} height={20} />
                  </div>
                </div>
              </>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
